/**
 * @generated SignedSource<<a4e60735dad0e5e89fcff29cc77d12f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomebasePartnersPaginationQuery$variables = {
  count?: number | null;
  locations?: ReadonlyArray<string> | null;
  offset?: number | null;
};
export type HomebasePartnersPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomebasePartners_partners">;
};
export type HomebasePartnersPaginationQuery = {
  response: HomebasePartnersPaginationQuery$data;
  variables: HomebasePartnersPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 3,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "locations"
  },
  {
    "defaultValue": 0,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = {
  "kind": "Variable",
  "name": "locations",
  "variableName": "locations"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomebasePartnersPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HomebasePartners_partners"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomebasePartnersPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "concreteType": "HomebasePartnerNodeConnection",
        "kind": "LinkedField",
        "name": "homebasePartners",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HomebasePartnerNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HomebasePartnerNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fee",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "location",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliverables",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "about",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0f05fa83e880d3bcbb70333805483ee",
    "id": null,
    "metadata": {},
    "name": "HomebasePartnersPaginationQuery",
    "operationKind": "query",
    "text": "query HomebasePartnersPaginationQuery(\n  $count: Int = 3\n  $locations: [String!] = []\n  $offset: Int = 0\n) {\n  ...HomebasePartners_partners_CssVV\n}\n\nfragment HomebasePartners_partner on HomebasePartnerNode {\n  id\n  name\n  url\n  fee\n  location\n  deliverables\n  about\n}\n\nfragment HomebasePartners_partners_CssVV on Query {\n  homebasePartners(first: $count, offset: $offset, locations: $locations) {\n    edges {\n      node {\n        id\n        ...HomebasePartners_partner\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db09c4650094f3b637d929d04924a323";

export default node;
